import React from "react";
import MiniHero from "components/miniHero";

const Contact: React.FC = () => {
  return (
    <div>
      <MiniHero image="/images/Gallery/DSC09976.jpg" text="Kontakta Oss" />
      <section className="w-full flex items-center justify-center mt-16 py-16 pb-32">
        <div className="container mx-auto flex flex-col md:flex-row items-center px-8 lg:px-20 max-w-6xl gap-12">
          {/* Left Image Section */}
          <div className="w-full md:w-1/2 flex justify-center">
            <img
              src="/images/Hanna/DSC09748-min.jpg"
              alt="Hanna Olsson"
              className="rounded-lg shadow-lg max-w-sm"
            />
          </div>

          {/* Right Text Section */}
          <div className="w-full md:w-1/2 text-left">
            <h1
              className="text-4xl font-bold text-gray-800 mb-6"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            ></h1>
            <div style={{ fontFamily: "'IBM Plex Mono', monospace" }}>
              <p className="text-lg text-gray-600 mb-4">
                Välkomna till Lada Basteskår – en plats för träning och
                gemenskap. Låt oss hjälpa dig att nå dina mål med hjälp av våra
                engagerade coacher och ett brett utbud av tjänster.
              </p>
              <p className="text-lg text-gray-600 mb-4">
                Har du frågor om träning, massage, eller våra företagslösningar?
                Hör av dig till oss så hjälper vi dig gärna.
              </p>
              <p className="text-lg text-gray-600 mb-4">
                Hitta oss på <strong>Basteskår 420</strong>, där parkering och
                ingång finns på nedsidan/framsidan av gården.
              </p>
              <p className="text-lg text-gray-600">
                För att boka träning eller massage, besök vår sida på{" "}
                <a
                  href="https://www.bokadirekt.se/places/lada-basteskar-60229"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  Boka Direkt
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
